export default {
  getNotifications(start, end) {
    const obj = {
      actionType: appConstants.ActionTypes.GET_NOTIFICATIONS,
      postData: {},
    };
    obj.postData[Utils.getEndpointParam('START_PARAM')] = start;
    obj.postData[Utils.getEndpointParam('END_PARAM')] = end;
    MakeShiftEmployeeDispatcher.dispatch(obj);
  },

  markAsRead(notificationId) {
    const obj = {
      actionType: appConstants.ActionTypes.MARK_NOTIFICATION_AS_READ,
      postData: {
        'notification_id': notificationId
      },
    };
    MakeShiftEmployeeDispatcher.dispatch(obj);
  },

  markAllAsRead() {
    const obj = {
      actionType: appConstants.ActionTypes.MARK_ALL_NOTIFICATIONS_AS_READ,
      postData: {},
    };
    MakeShiftEmployeeDispatcher.dispatch(obj);
  }

};